module.exports = __webpack_public_path__ + "img/129.702b97b4.jpg";